export class GraphQLError extends Error {
  __proto__: Error;
  constructor(
    public operationName: string,
    public variables?: Record<string, string>) {
    super();
    // allows for instanceof operator
    const proto = new.target.prototype;
    this.__proto__ = proto;
  }

  get message(): string {
    return `Bad response from ${this.operationName}`;
  }

  toString(): string {
    return this.message;
  }
}
